import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  Facebook,
  Instagram,
  Youtube,
  InfoCircle,
  Tag,
  Bag,
  GeoAlt,
  Telephone,
  Envelope,
  BriefcaseFill,
} from "react-bootstrap-icons";

export default function Footer() {
  return (
    <footer
      className="py-5"
      style={{
        background: "linear-gradient(to top, #333, #444)",
        color: "#fff",
      }}
    >
      <Container>
        <Row className="gy-4 text-center text-md-start">
          {/* About Us */}
          <Col xs={12} md={3}>
            <div className="d-flex justify-content-center justify-content-md-start align-items-center gap-2 mb-3">
              <InfoCircle />
              <h5 className="fw-bold m-0">About Us</h5>
            </div>
            <p className="mb-3" style={{ lineHeight: 1.6 }}>
              Madhu Sewing Machine is your trusted destination for all your
              sewing machine needs. We offer quality products and exceptional
              service.
            </p>
            <div className="d-flex gap-3 justify-content-center justify-content-md-start">
              <a href="https://www.facebook.com/madhusewingmachines1/" target="_blank" rel="noopener noreferrer" className="text-light" aria-label="Facebook">
                <Facebook size={22} />
              </a>
              <a href="https://www.instagram.com/madhusewingmachines/" target="_blank" rel="noopener noreferrer" className="text-light" aria-label="Instagram">
                <Instagram size={22} />
              </a>
              <a href="https://www.youtube.com/@MadhusewingMachine" target="_blank" rel="noopener noreferrer" className="text-light" aria-label="YouTube">
                <Youtube size={22} />
              </a>
            </div>
          </Col>

          {/* Shop by Category */}
          <Col xs={12} md={3}>
            <div className="d-flex justify-content-center justify-content-md-start align-items-center gap-2 mb-3">
              <Tag />
              <h5 className="fw-bold m-0">Shop by Category</h5>
            </div>
            <ul className="list-unstyled mb-0 text-center text-md-start">
              <li className="mb-2">
                <Link to="/shop-by-category" className="text-light text-decoration-none">
                  New Domestic Machine
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/shop-by-category" className="text-light text-decoration-none">
                  Reconditioned Domestic Machine
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/shop-by-category" className="text-light text-decoration-none">
                  New Industrial Machine
                </Link>
              </li>
            </ul>
          </Col>

          {/* Choose By Brand */}
          {/* <Col xs={12} md={3}>
            <div className="d-flex justify-content-center justify-content-md-start align-items-center gap-2 mb-3">
              <Bag />
              <h5 className="fw-bold m-0">Choose By Brand</h5>
            </div>
            <ul className="list-unstyled mb-0 text-center text-md-start">
              <li className="mb-2">
                <Link to="/shop-by-brands" className="text-light text-decoration-none">
                  SINGER
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/shop-by-brands" className="text-light text-decoration-none">
                  BROTHER
                </Link>
              </li>
              <li className="mb-2">
                <Link to="/shop-by-brands" className="text-light text-decoration-none">
                  USHA
                </Link>
              </li>
            </ul>
          </Col> */}

          {/* Contact Information */}
          <Col xs={12} md={3}>
            <div className="d-flex justify-content-center justify-content-md-start align-items-center gap-2 mb-3">
              <GeoAlt />
              <h5 className="fw-bold m-0">Contact Information</h5>
            </div>
            <div className="text-center text-md-start">
              <p className="mb-2 d-flex justify-content-center justify-content-md-start align-items-center gap-2">
                <GeoAlt />
                <span>216, 1st Cross, Magadi Main Rd, near Prasanna Theater, Vidyaranya Nagar, Bengaluru, Karnataka 560023</span>
              </p>
              <p className="mb-2 d-flex justify-content-center justify-content-md-start align-items-center gap-2">
                <Telephone />
                <span>6366718889</span>
              </p>
              <p className="mb-0 d-flex justify-content-center justify-content-md-start align-items-center gap-2">
                <Envelope />
                <a
                  href="mailto:info@madhusewing.com"
                  className="text-decoration-none text-light"
                >
                  info@madhusewing.com
                </a>
              </p>
            </div>
          </Col>
        </Row>

        <hr className="my-4 border-light" />

        <Row className="gy-2 text-center text-md-start">
          {/* Copyright */}
          <Col xs={12} md={6}>
            <p className="mb-0">© 2025 Madhu Sewing Machine. All rights reserved.</p>
          </Col>  

          {/* Developed By */}
          <Col xs={12} md={6} className="d-flex justify-content-center justify-content-md-end">
            <p className="mb-0 d-flex align-items-center gap-2">
              <BriefcaseFill size={18} />
              <a href="https://parnetsgroup.com/" target="_blank" rel="noopener noreferrer" className="text-light text-decoration-none">
                Developed by Parnets Software Ind Pvt Ltd
              </a>
            </p>
          </Col>

          {/* Links */}
          <Col xs={12} className="text-center mt-2">
            <Link to="/privacy-policy" className="text-light text-decoration-none me-3">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-light text-decoration-none">
              Terms & Conditions
            </Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
